<!--页脚-->
<template>
  <div class="content-footer">
    <p>地址：{{foot.addr}} &nbsp; &nbsp; 邮政编码： {{foot.code}} &nbsp; &nbsp; 电话：{{foot.tel}} &nbsp; &nbsp; E-mail：{{foot.mail}}</p>
    <p>版权所有 © 2016-2019 广东省仪器仪表学会 &nbsp; &nbsp; 技术支持：广州德禄讯信息科技有限公司 &nbsp; &nbsp; <a href="http://beian.miit.gov.cn/" style="color:white;">{{foot.beian}}</a></p>
    <span>友情链接：</span><a v-for="(l, index) in link" :href="l[1]" :key="index" style="color: #ffffff;margin-left: 7px;">{{l[0]}}</a>
  </div>
</template>

<script>
import HttpServer from '@/utils' // 接口请求
export default {
  data () {
    return {
      foot: '',
      link: []
    }
  },
  mounted () {
    // 调用底部接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index/foot').then(res => {
      this.foot = res
    })
    // 调用主页接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index').then(res => {
      this.link = res.link
    })
  }
}
</script>

<style>
  .content-footer{
    width: 100%;
    min-width:950px;
    height: 160px;
    padding-top: 45px;
    background-color: #0064e7;
    color: #ffffff;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue